<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button [text]="'GENERAL.NAVIGATION.BACK' | translate" defaultHref="/home"/>
    </ion-buttons>
    <ion-title>
      {{ 'LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.HEADER_TITLE' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>
        {{ 'LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.SALUTE' | translate }}
      </ion-card-title>
    </ion-card-header>
    <ion-card-content class="card-padding">
      <span>{{ 'LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.DESCRIPTION' | translate }}</span>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-content>
      <app-team-login-register-user-form (formChange)="onFormChange($event)"
                                         [existingEmail]="currentEmail"/>
    </ion-card-content>
  </ion-card>
  <ion-card class="ion-no-padding card-button">
    @if (!(isLoading$ | async)) {
      <ion-button (click)="submit()"
                  [disabled]="registerUserShadowForm.invalid" class="submit" expand="block">
        {{ 'LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.BUTTONS.SUBMIT' | translate }}
      </ion-button>
    }
    @if (isLoading$ | async) {
      <ion-button [disabled]="true"
                  class="submit" expand="block">
        <ion-spinner/>
      </ion-button>
    }
  </ion-card>
</ion-content>
